/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import axios from "axios";
import { Badge, Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import config from "../../../../config.json";
import "../../../i18n";
import { useTranslation } from "react-i18next";

const CategoriesHistory = ({
  category,
  fetchCategories,
  selected = false,
  onToggleSelect,
}) => {
  const { t } = useTranslation();
  const {
    // name,
    _id,
    photo,
    categoryDetails = [],
    isArchived,
  } = category;

  const restoreCategory = async () => {
    try {
      await axios
        .put(
          `${config.dev}/v2/categories/restore/${_id}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("tokenLogin")}`,
            },
          }
        )
        .then(() => {
          swal(t("successTitle"), t("categoryIsActivated"), t("success"));
        });
      fetchCategories();
    } catch (error) {
      swal(t("errorTitle"), "" + error, t("error"));
    }
  };
  const deleteCategoryForever = async () => {
    const ok = await swal({
      title: t("areYouSure") || "Are you sure?",
      text: t("deleteForeverWarning") || "This action cannot be undone.",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });
    if (!ok) return;
    try {
      await axios.delete(`${config.dev}/v2/categories/delete/${_id}`);
      swal(t("successTitle"), t("deletedSuccessfully") || "Deleted permanently", t("success"));
      fetchCategories();
    } catch (error) {
      swal(t("errorTitle"), error?.response?.data?.message || "" + error, t("error"));
    }
  };
  if (!isArchived) return null;
  return (
    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-4">
      {isArchived ? (
        <div className="card">
          <div className="card-body">
            <div className="new-arrival-product">
              <div className="d-flex justify-content-start mb-2">
                <input
                  type="checkbox"
                  className="form-check-input"
                  checked={selected}
                  onChange={(e) => onToggleSelect?.(_id, e.target.checked)}
                />
              </div>
              <div className="d-flex justify-content-end">
                <div className="basic-dropdown">
                  <Dropdown>
                    <Dropdown.Toggle
                      as="button"
                      variant=""
                      className="btn sharp btn-primary tp-btn mt-1"
                      id="tp-btn"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        width="18px"
                        height="18px"
                        viewBox="0 0 24 24"
                        version="1.1"
                      >
                        <g
                          stroke="none"
                          strokeWidth="1"
                          fill="none"
                          fillRule="evenodd"
                        >
                          <rect x="0" y="0" width="24" height="24" />
                          <circle fill="#000000" cx="12" cy="5" r="2" />
                          <circle fill="#000000" cx="12" cy="12" r="2" />
                          <circle fill="#000000" cx="12" cy="19" r="2" />
                        </g>
                      </svg>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item
                        href={`https://admin.clictoeat.com/category-details/${_id}`}
                      >
                        <i className="fa fa-eye me-2"></i>
                        {t("details")}
                      </Dropdown.Item>

                      <Dropdown.Item
                        onClick={() => {
                          restoreCategory();
                        }}
                      >
                        <i className="fa fa-archive me-2"></i>
                        {t("restore")}
                      </Dropdown.Item>
                      <Dropdown.Item onClick={deleteCategoryForever}>
                        <i className="fa fa-trash me-2 text-danger"></i>
                        {t("deleteForever") || "Delete forever"}
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
              <div className="new-arrivals-img-contnent">
                <img
                  className="img-fluid"
                  src={
                    photo ? `${config.UPLOADS_SERVER}/category/${photo} ` : null
                  }
                  alt={"Image-Preview"}
                  style={{
                    height: "200px",
                    objectFit: "cover",
                    borderRadius: "8px",
                  }}
                />
              </div>
              {/* Contenu du produit */}
              <div className="new-arrival-content text-center mt-3">
                <h4>
                  <Link to="/ecom-product-detail" className="text-black">
                    {categoryDetails.map((item) =>
                      item.language === "en" ? item.categoryTitle : null
                    )}
                  </Link>
                </h4>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default CategoriesHistory;
